module.exports = __webpack_public_path__ + "img/73-l.6f2695cc.png";